<header class='content-header' *ngIf='isSiteContext'>
  <h4 class='vision-h4'>Tasks</h4>
</header>

<div class='action-bar' [ngClass]="{ 'content-header': isSiteContext }">
  <fw-button-toggle [value]='viewFilter'
                    (change)='changeView($event)'
                    class='view-toggle' test-id='view-toggle'>
    <fw-button-toggle-item [class.hidden]="!isSiteAdmin && !canManage" title="All tasks" value="all"></fw-button-toggle-item>
    <fw-button-toggle-item title="Assigned to me" value="assigned"></fw-button-toggle-item>
    <fw-button-toggle-item title="Created by me" value="created"></fw-button-toggle-item>
  </fw-button-toggle>
  <div class='action-buttons' *ngIf='canManage'>
    <fw-button *ngIf="shouldShowClearFiltersSort" test-id='clear-filters'
      variant="outline" leftIcon="filter-sort-delete"
      (click)='changeView(filters.get("viewFilter").value)' [fwTooltip]='clearFilterSortTooltip'>
        Clear Filters
    </fw-button>
    <fw-button *ngIf='(someTasksSelected || allTasksSelected)' test-id='delete-tasks'
      variant='outline' color="danger" leftIcon="trash-delete"
      [disabled]='!canDeleteSelection'
      [fwTooltip]="canDeleteSelection ? '' : 'You do not have permission to delete the selected tasks.'"
      (click)='deleteTasks(getSelectedTasks())'>
        Delete Selected Tasks
    </fw-button>
    <fw-button *ngIf='canReadTaskReview && selectionValidViewMultiple' variant="solid" test-id='view-multiple'
      color='primary' (click)='viewSelectedTasks()'>
        Launch Tasks in Viewer
    </fw-button>
    <fw-button mat-flat-button test-id='new-tasks' color='primary' variant="solid" (click)='newTasks()'
      fwTooltip="Launch tasks creation panel">
        New Tasks
    </fw-button>
  </div>
  <fw-button test-id='open-columns-menu' color="primary" variant="outline"
    leftIcon="column-edit" [matMenuTriggerFor]='filterColumnMenu'>
      Edit Columns
  </fw-button>
  <mat-menu test-id='columns-menu' #filterColumnMenu='matMenu' class='columns-menu'>
    <mat-checkbox
      *ngFor='let column of disabledColumns'
      [attr.test-id]="'column-checkbox-' + column.key"
      class='mat-menu-item'
      (click)='$event.stopPropagation()'
      (change)='persistColumns()'
      [(ngModel)]='column.enabled'>
      {{ column.label | translate }}
    </mat-checkbox>
  </mat-menu>
</div>

<div [ngClass]="{ 'content-body': isSiteContext }">
  <div class='table-wrapper'>
    <table mat-table matSort matSortDisableClear
           [dataSource]='tasksData$'
           [matSortActive]='tasksSort$.value.active'
           [matSortDirection]='tasksSort$.value.direction'
           (matSortChange)='tasksSort$.next($event)'>

      <ng-container matColumnDef='checkbox'>
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox [checked]='allTasksSelected' [disabled]='!selectableTasksPresent' test-id="select-all-tasks"
                        [indeterminate]='someTasksSelected'
                        (change)='setAllTasksSelected($event.checked)' test-id="select-all-tasks-checkbox"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef='let element' class='text-left'>
          <mat-checkbox [attr.test-id]="'select-project-' + element.projectId"
                        [disabled]='!authorizedProjects[element.projectId]'
                        [checked]='element.selected'
                        [fwTooltip]="!authorizedProjects[element.projectId] ? 'You do not have permission to delete the selected tasks.' : null"
                        [fwTooltip]="!authorizedProjects[element.projectId] ? 'You do not have permission to delete the selected tasks.' : null"
                        (change)='selectRow($event.checked, element)'
                        (click)='$event.stopPropagation()'>
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef='project'>
        <th mat-header-cell *matHeaderCellDef>
          <project-picker class="small-form-field" test-id='project-filter' [(multiValue)]='projectFilter' [useSolidBackground]='false'
                          [useMultiSelect]='true'></project-picker>
        </th>
        <td mat-cell *matCellDef='let element' fwTooltip='{{ element.projectLabel }}'>
          {{ element.projectLabel }}
        </td>
      </ng-container>

      <ng-container matColumnDef='task_id'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='task-id full-width'>
          <mat-form-field class="small-form-field" appearance='outline'>
            <input test-id='task-id-filter' type='text' matInput [formControl]="$any(filters.get('taskId'))"
                   placeholder="Task ID"
                   autocomplete='off' (keydown)='$event.stopPropagation()' (click)='$event.stopPropagation()'>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef='let element' class='task-id'>
          <div class='flex-wrapper'>
            <span [fwTooltip]='element.taskId'>{{ element.taskId }}</span>
            <mat-icon class='xs' (click)='$event.stopPropagation(); viewTask(element._id, element.viewer)'
                      fwTooltip="View Read Task">panorama
            </mat-icon>
            <mat-icon class='xs'
              *ngIf='canDownloadFiles(element.projectId)'
              (click)='$event.stopPropagation(); downloadTaskFiles(element)'
              fwTooltip="Download Associated File">cloud_download
            </mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef='task_type'>
        <th mat-header-cell class='task-type' *matHeaderCellDef>Task Type</th>
        <!-- TODO // uncomment when more protocols are available
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="task-type full-width">
          <mat-form-field appearance="outline">
            <mat-select test-id="project-roles-filter" [formControl]="filters.get('taskType')" placeholder="Task Type"
              (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
              <mat-option *ngFor="let option of taskTypeOptions" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        -->
        <td mat-cell *matCellDef='let element' class='task-type' [fwTooltip]='getTaskTypeDisplay(element)'>
          {{ getTaskTypeDisplay(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef='container'>
        <th mat-header-cell *matHeaderCellDef>Container</th>
        <td mat-cell *matCellDef='let element'>
          <fw-ellipsis [text]="element?.container?.label || ''" [tooltip]='element?.container?.hierarchy'></fw-ellipsis>
        </td>
      </ng-container>

      <ng-container matColumnDef='assignee'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='full-width'>
          <app-typeahead
            class='full-width small-form-field'
            test-id='assignee-filter'
            [options]='userOptions'
            placeholder="Assignee"
            [(value)]='assigneeFilter'
            (keydown)='$event.stopPropagation()'
            (click)='$event.stopPropagation()'>
          </app-typeahead>
        </th>
        <td mat-cell *matCellDef='let element' [fwTooltip]='element.assignee?._id'>
          <div class='flex-wrapper'>
            <app-avatar [users]='element.assignee' [enablePopover]='false' [enableAnimation]='true'></app-avatar>
            <span class='ellipsis-block'>
              {{ element.assignee?.firstname }} {{ element.assignee?.lastname }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef='creator'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='full-width'>
          <app-typeahead
            class='full-width small-form-field'
            test-id='creator-filter'
            [options]='userOptions'
            placeholder="Creator"
            [(value)]='creatorFilter'
            (keydown)='$event.stopPropagation()' (click)='$event.stopPropagation()'>
          </app-typeahead>
        </th>
        <td mat-cell *matCellDef='let element' [fwTooltip]='element.creator?._id'>
          <div class='flex-wrapper'>
            <app-avatar [users]='element.creator' [enablePopover]='false' [enableAnimation]='true'></app-avatar>
            <span class='ellipsis-block'>
              {{ element.creator?.firstname }} {{ element.creator?.lastname }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef='created'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header
            class='created'>Created
        </th>
        <td mat-cell *matCellDef='let element' [fwTooltip]='element.created?.tooltip' class='created'>
          {{ element.created.display }}
        </td>
      </ng-container>

      <ng-container matColumnDef='due'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header
            class='due-date'>Due Date
        </th>
        <td mat-cell *matCellDef='let element' [fwTooltip]='element.dueDate.tooltip' class='due-date'
            [ngClass]="{ 'red': element.dueDate.isOverdue }">
          <div class='flex-wrapper'>
            <mat-icon *ngIf='element.dueDate.isOverdue' class='xs'>warning_amber</mat-icon>
            {{ element.dueDate.display }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef='status'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='status full-width'>
          <mat-form-field appearance='outline' class='full-width small-form-field'>
            <mat-select test-id='status-filter' [formControl]="$any(filters.get('status'))"
                        placeholder="Status"
                        (keydown)='$event.stopPropagation()' (click)='$event.stopPropagation()'>
              <mat-option *ngFor='let option of statusOptions' [value]='option.value'>{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef='let element' class='status'>
          <div class='flex-wrapper' [ngClass]='element.status.className'>
            <mat-icon *ngIf='element.status.isComplete' class='xs'>check_circle_outline</mat-icon>
            {{ element.status.display }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef='tag'>
        <th mat-header-cell test-id='tag-header' *matHeaderCellDef>
          <mat-form-field class="small-form-field" [formGroup]='filters'>
            <mat-chip-grid #chipList formControlName='tags'>
              <mat-chip-row *ngFor='let value of filters.controls.tags.value; index as chipIndex' class='chip'
                        (removed)='removeTagFilter(chipIndex)'>
                {{ value }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              <input test-id='filter-chips' #chipInput formControlName='tagText'
                     placeholder="Tags"
                     *ngIf='filters?.controls?.tags?.value?.length === 0' [matChipInputFor]='chipList'
                     [matChipInputAddOnBlur]='true' (matChipInputTokenEnd)='addTagFilter($event)'>
            </mat-chip-grid>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef='let element; let i = index;' style='position: relative'>
          <mat-chip-grid #chipList [attr.test-id]="'chip-list-' + i" class='chip-list'>
            <mat-chip-row *ngFor='let tag of element.tags'>
              {{ tag }}
            </mat-chip-row>
          </mat-chip-grid>
          <div class='chip-ellipsis' [style.left]="tagOverflows[i] ? tagOverflows[i].ellipsisOffsetLeft : 'none'"
               [class.hidden]='tagOverflows[i]?.hiddenItemCount === 0'>
            <mat-chip-option *ngIf='tagOverflows[i]?.hiddenItemCount > 0' class='more-chip'
                      [fwTooltip]='tagOverflows[i].hiddenItemsTooltip'>
              {{ labels.more | interpolate:tagOverflows[i] ? tagOverflows[i].hiddenItemCount : '' }}
            </mat-chip-option>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef='actions'>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef='let element' class='text-right list-action-buttons'>
          <mat-icon class='action-icon xs'
                    [ngClass]="{ 'disabled': !authorizedProjects[element.projectId] }"
                    [fwTooltip]="!authorizedProjects[element.projectId] ? 'You do not have permission to delete the selected tasks.' : 'Delete'"
                    (click)='$event.stopPropagation(); authorizedProjects[element.projectId] && deleteTasks([element])'>
            delete
          </mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef='displayedColumns; sticky: true '></tr>
      <tr mat-row *matRowDef='let row; columns: displayedColumns;' class='list-action-hover'
          (click)='editTask(row)'></tr>

    </table>
    <div #fwLoadTrigger (fwLoadTrigger)='loadMore()' class='load-trigger'></div>

    <fw-loading *ngIf='isLoading'></fw-loading>

    <div *ngIf='!isLoading && !hasData && !hasLoadingError' class='empty blank-state'>
      <mat-icon class='sm raised blue'>block</mat-icon>
      <p>{{ 'tasks.content.noData' | translate }}</p>
    </div>

    <div *ngIf='hasLoadingError' class='empty blank-state'>
      <mat-icon class='sm raised red'>priority_high</mat-icon>
      <p>There was an error loading tasks</p>
    </div>

  </div>
</div>
